/* ─── Impressum page — section and block styles ─────────────────────────── */

.pageWrapper {
  min-height: 100vh;
  display: flex;
  flex-direction: column;
  background-color: var(--color-bg-primary);
}

.main {
  flex: 1;
}

.section {
  margin: 0 0 40px;
  padding-bottom: 40px;
  border-bottom: 1px solid var(--color-border);
}

.section:last-of-type {
  border-bottom: none;
}

.sectionTitle {
  font-size: 1.25rem;
  font-weight: 700;
  margin: 0 0 20px;
  color: var(--color-text-primary);
  line-height: 1.3;
}

.subSection {
  margin: 0 0 24px;
}

.subSectionTitle {
  font-size: 1rem;
  font-weight: 700;
  margin: 0 0 8px;
  color: var(--color-text-primary);
}

.paragraph {
  margin: 0;
  color: var(--color-text-secondary);
  line-height: 1.7;
}

.fieldLabel {
  font-weight: 700;
  color: var(--color-text-primary);
}

.addressBlock {
  margin: 4px 0 0;
  color: var(--color-text-secondary);
  line-height: 1.7;
  font-style: normal;
}

.emailLink {
  color: var(--color-accent);
  text-decoration: underline;
  text-underline-offset: 2px;
}

.emailLink:hover {
  color: var(--color-accent-hover);
}

.emailNote {
  display: block;
  margin-top: 4px;
  font-style: italic;
  color: var(--color-text-muted);
  font-size: 0.875rem;
}

.infoDate {
  margin-top: 32px;
  font-size: 0.875rem;
  color: var(--color-text-muted);
}
